<template>
    <!-- Card container -->
    <div
        :class="[
            'relative flex flex-col justify-between rounded-3xl border p-6',
            variantClasses.card,
            autoSize ? 'w-full' : 'size-80',
            centerIcon ? 'items-center' : 'items-start',
        ]"
    >
        <div
            :class="[
                'w-fit  p-2',
                variantClasses.iconBorder,
                hideIconHalo ? '' : 'rounded-full border',
            ]"
        >
            <component
                :is="currentIcon"
                v-if="currentIcon"
                :class="['size-6', variantClasses.iconColor]"
            />
        </div>

        <div
            :class="[
                'absolute top-[45%] ',
                variantClasses.text,
                autoSize ? 'w-full' : 'max-w-72',
            ]"
        >
            <!-- Card Title -->
            <div class="mb-2 font-600 text-lg">{{ title }}</div>
            <!-- Card Body -->
            <div
                :class="[
                    'max-w-[98%] pr-6 text-base font-light',
                    variantClasses.bodyText,
                    autoSize ? 'pr-12' : '',
                ]"
            >
                {{ body }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import IconChatCircleDots from '~/components/Icon/IconChatCircleDots.vue'
import IconCheckCircleFilled from '~/components/Icon/IconCheckCircleFilled.vue'
import IconCurrency from '~/components/Icon/IconCurrency.vue'
import IconDesktopMonitor from '~/components/Icon/IconDesktopMonitor.vue'
import IconExport from '~/components/Icon/IconExport.vue'
import IconQuestion from '~/components/Icon/IconQuestion.vue'
import IconSparkle from '~/components/Icon/IconSparkle.vue'
import IconSuitcaseRolling from '~/components/Icon/IconSuitcaseRolling.vue'
import IconWrench from '~/components/Icon/IconWrench.vue'

const props = defineProps<{
    icon: string
    title: string
    body: string
    variant: 'light' | 'dark'
    hideIconHalo?: boolean
    centerIcon?: boolean
    autoSize?: boolean
}>()

const icons = new Map<string, any>([
    ['sparkles', IconSparkle],
    ['import', IconExport],
    ['coin', IconCurrency],
    ['suitcase', IconSuitcaseRolling],
    ['question', IconQuestion],
    ['desktop', IconDesktopMonitor],
    ['dotsMessage', IconChatCircleDots],
    ['wrench', IconWrench],
    ['check', IconCheckCircleFilled],
])

const currentIcon = computed(() => icons.get(props.icon) || null)

const variantClasses = computed(() => ({
    card:
        props.variant === 'dark'
            ? 'bg-neutral-1000 border-neutral-50 border-4 shadow-md'
            : 'bg-neutral-50 shadow-md border-neutral-50',
    iconBorder:
        props.variant === 'dark' ? 'border-neutral-900' : 'border-neutral-200',
    iconColor:
        props.variant === 'dark' ? 'text-[#D2EEFF]' : 'text-neutral-1000',
    text: props.variant === 'dark' ? 'text-neutral-50' : 'text-neutral-1000',
    bodyText: props.variant === 'dark' ? 'text-neutral-50' : 'text-neutral-600',
}))
</script>

<style scoped>
/* Add any additional styles here if needed */
</style>
